import LayoutMarkdown from './layout-markdown'
import React from 'react'

export default ({ children }) => {
  return <LayoutMarkdown dark={true}>{children}</LayoutMarkdown>
}
